const Tools = {

    // FIELDS
    "tools": "Tools",
    "name": "Name",
    "description": "Description",
    "status": "Status",
    "search": "Search",
    
    // PAGE HEADER
    "list_title": "Tools",
    "filter_title": "Tools Filter",
    
    // TABLE HEADER
    "table_name": "Name",
    "table_description": "Description",
    "table_status": "Status",
    "table_action": "Action",
    
    // ERROR
    "error_name": "Enter Name",
    "error_description": "Enter Description",
    "error_status": "Select Status",

}

export default Tools;

